import React, { useEffect, useMemo, useState } from 'react'
import * as Yup from 'yup';
import moment from 'moment';
import { Collapse, Icon, Row, Tooltip, Modal } from 'antd';
import { Button, FormDatePicker, FormInput, FormSelect, FormSubmitButton, InlineEditColumnProps, InlineEditTable, MasterDetailForm, OptionProps, Widget, notification, usePromise } from '@digital/ui';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { objToFormData } from '@app/utils/utils';
import { IPermissoesSubcontratacao, createSubcontratacao, deleteSubcontratacao, devolverSubcontratacao, downloadAnexoSubcontratacao, getComentariosSubcontratacao, getPermissoesSubcontratacao, getSubcontratacoesContrato, salvarComentarioSubcontratacao, salvarNovasSubcontratadasAutorizadas, submeterSubcontratacao, updateSubcontratacao, viewAnexoSubcontratacao } from '@app/api/contrato/subcontratacoes';
import { optionsSwitch } from '@app/helpers/optionsSwitch';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import ModalComentarioButton from '@app/components/ModalComentarios';
import { Space, UploadComponent, Visibility } from '@app/components';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { AbaGeralContrato } from '@app/api/contrato/geral';
import { getAllStatusSubcontratacaoOptions } from '@app/api/status';
import { get } from 'lodash';
import { GetFileExtension, imageFormats } from '@app/helpers';
const { Panel } = Collapse;

export interface AbaSubcontratacoesProps {
    contratoId: string
    dadosGerais: AbaGeralContrato
    onUpdateDadosGerais: () => void
    onUpdateContratos: () => void
}

export const AbaSubcontratacoes = (props: AbaSubcontratacoesProps) => {
    const { contratoId, dadosGerais, onUpdateDadosGerais, onUpdateContratos } = props
    const [update, setUpdate] = useState(false)
    const [subcontratacoes, setSubcontratacoes] = useState<any[]>([])
    const [isNovasSubcontratadasAutorizadas, setIsNovasSubcontratadasAutorizadas] = useState<boolean | undefined>(undefined)
    const [permissoes, setPermissoes] = useState<IPermissoesSubcontratacao>()
    const [statusSubcontratacaoOptions] = usePromise(getAllStatusSubcontratacaoOptions, [], [] as OptionProps[]);
    const [initialValuesCadastro, setInitialValuesCadastro] = useState({ contratoId: contratoId })

    const onUpdate = () => {
        setUpdate(!update);
        onUpdateDadosGerais();
        onUpdateContratos();
    }

    const submitCadastroSubcontratacao = (values) => {
        let form = objToFormData(values)
        createSubcontratacao(form).then((response) => {
            if (response && response.valid) {
                setInitialValuesCadastro(null)
                setInitialValuesCadastro({ contratoId: contratoId })
                onUpdate()
            }
        })
    }

    const handleEditSubcontratacao = (record: any) => {
        return updateSubcontratacao(record).then((response) => {
            if (response && response.valid) {
                getSubcontratacoes()
            }
        })
    }

    const handleDeleteSubcontratacao = (id: string) => {
        Modal.confirm({
            title: 'Deletar',
            content: 'Deseja deletar a subcontratação? Essa ação não poderá ser desfeita.',
            okText: 'Sim',
            cancelText: 'Não',
            onOk: () => {
                deleteSubcontratacao(id).then((response: any) => {
                    if (response && response.valid) {
                        getSubcontratacoes()
                    }
                })
            }
        })
    }

    const getSubcontratacoes = () => {
        getSubcontratacoesContrato(contratoId).then((response) => {
            if (response) {
                setSubcontratacoes(response)
            }
        })
    }

    const getPermissoes = () => {
        getPermissoesSubcontratacao(contratoId).then((response) => {
            if (response) {
                setPermissoes(response)
            }
        })
    }

    const getComentariosSubcontratacaoFunc = async (subcontratacaoId: string) => {
        const comentarios = await getComentariosSubcontratacao(subcontratacaoId)
        return comentarios || []
    }


    const onSubmitSalvarNovasSubcontratadasAutorizadas = (values: any) => {
        const form = new FormData()
        form.append('contratoId', contratoId)
        form.append('isNovasSubcontratadasAutorizadas', values.isNovasSubcontratadasAutorizadas)
        salvarNovasSubcontratadasAutorizadas(form).then(data => {
            if (data && data.valid) {
                onUpdate()
            }
        })
    }

    const onClickSubmeter = () => {
        if (isNovasSubcontratadasAutorizadas) {
            Modal.confirm({
                title: 'Submeter',
                content: 'Deseja concluir a atividade?',
                okText: 'Sim',
                cancelText: 'Não',
                onOk: () => onSubmeter()
            })
        }

        if (!isNovasSubcontratadasAutorizadas) {
            onSubmeter()
        }
    }

    const onSubmeter = () => {
        submeterSubcontratacao({ contratoId, isNovasSubcontratadasAutorizadas }).then(data => {
            if (data && data.valid) {
                onUpdate()
            }
        })
    }

    const onClickDevolver = () => {
        const hasEmCorrecao = subcontratacoes.some(item => item.statusSubcontratacao === "Em correção");
    
        if(hasEmCorrecao){
            Modal.confirm({
                title: 'Devolver',
                content: 'Deseja devolver as subcontratações?',
                okText: 'Sim',
                cancelText: 'Não',
                onOk: () => {
                    hasEmCorrecao && onDevolver()
                }
            })
        }else{
            notification.warn('Não há subcontratações em correção para devolver.')
        }
        
    }

    const onDevolver = () => {
        devolverSubcontratacao(contratoId).then(data => {
            if (data && data.valid) {
                onUpdate()
            }
        })
    }

    useEffect(() => {
        if (contratoId) {
            getSubcontratacoes()
            getPermissoes()
        }
        if (isObjNotEmpty(dadosGerais)) {
            setIsNovasSubcontratadasAutorizadas(dadosGerais.isNovasSubcontratadasAutorizadas)
        }
    }, [update, dadosGerais, contratoId])

    const disableStatus = (status: string) => {
        return (permissoes 
                    && (!permissoes.isPerfilAdministradorContrato 
                        && (permissoes.isFiscalContrato || permissoes.isGestorContrato)) && (status === "Em análise" || status === "Validada"));
    }

    const columns = () => {
        var collumns = [];

        collumns.push({
            title: 'Número',
            dataIndex: 'numero',
            width: '8%',
            renderEdit: (text: any, record: any) => {
                return (
                    <FormInput
                        span={12}
                        name='numero'
                        value={record.numero}
                        disabled
                    />
                )
            },
        })

        collumns.push({
            title: 'Subcontratada',
            dataIndex: 'subcontratada',
            // width: '20%',
            renderEdit: (text: any, record: any) => {
                //const validada = record.statusSubcontratacaoId === EGuidStatusSubcontratacao.Validada
                return (
                    <FormInput
                        span={10}
                        name='subcontratada'
                        disabled={!existeSubcontratacaoPendente || disableStatus(record.statusSubcontratacao)}
                        maxLength={300}
                    />
                )
            }
        })

        collumns.push({
            title: 'CNPJ',
            dataIndex: 'subcontratadaCnpj',
            renderEdit: (text: any, record: any) => {
                return (
                    <FormInput
                        span={10}
                        name='subcontratadacnpj'
                        disabled={!existeSubcontratacaoPendente || disableStatus(record.statusSubcontratacao)}
                        maxLength={300}
                    />
                )
            }
        })

        collumns.push({
            title: 'Mão de obra em PTR?',
            dataIndex: 'maoDeObraEmPTR',
            width: '8%',
            render: (text:any, record:any) => {
                if (record.maoDeObraEmPTR === true) return 'Sim'
                if (record.maoDeObraEmPTR === false) return 'Não'
                return ''
            },
            renderEdit: (text: any, record: any) => {
                //const validada = record.statusSubcontratacaoId === EGuidStatusSubcontratacao.Validada
                return (
                    <FormSelect
                        name='maoDeObraEmPTR'
                        options={optionsSwitch}
                        span={12}
                        disabled={!existeSubcontratacaoPendente || disableStatus(record.statusSubcontratacao)}
                    />
                )
            },
        })

        collumns.push({
            title: 'Data Início',
            dataIndex: 'dataInicio',
            width: '10%',
            render: (text: any, record: any) => {
                return (
                    <span>{moment(record.dataInicio).format('DD/MM/YYYY')}</span>
                )
            },
            renderEdit: (text: any, record: any) => {
                //const validada = record.statusSubcontratacaoId === EGuidStatusSubcontratacao.Validada
                return (
                    <FormDatePicker
                        name='dataInicio'
                        format={'DD/MM/YYYY'}
                        span={12}
                        disabled={!existeSubcontratacaoPendente || disableStatus(record.statusSubcontratacao)}
                    />
                )
            }
        })

        collumns.push({
            title: 'Data Fim',
            dataIndex: 'dataFim',
            width: '10%',
            render: (text, record) => {
                return (
                    <span>{moment(record.dataFim).format('DD/MM/YYYY')}</span>
                )
            },
            renderEdit: (text: any, record: any) => {
                //const validada = record.statusSubcontratacaoId === EGuidStatusSubcontratacao.Validada
                return (
                    <FormDatePicker
                        name='dataFim'
                        format={'DD/MM/YYYY'}
                        span={12}
                        disabled={!existeSubcontratacaoPendente || disableStatus(record.statusSubcontratacao)}
                        validateSchema={Yup.date()
                            .required('Campo obrigatório')
                            .test('date-range', 'Data invlida', function (value) {
                            const dataInicio = record.dataInicio; // Accessing the value of dataInicio
                            const startDate = new Date(dataInicio);
                            const endDate = new Date(value);

                            return !startDate || !endDate || endDate >= startDate;
                        })}
                    />
                )
            }
        })

        collumns.push({
            title: 'Data Inclusão',
            dataIndex: 'createdAt',
            width: '12%',
            render: (text, record) => {
                return (
                    <span>{moment(convertUTCtoLocal(moment(record.createdAt))).format('DD/MM/YYYY')}</span>
                )
            },
            renderEdit: (text, record) => {
                return (
                    <FormDatePicker
                        span={12}
                        name='createdAt'
                        value={moment(convertUTCtoLocal(moment(record.createdAt)))}
                        format={'DD/MM/YYYY'}
                        disabled
                    />
                )
            }
        })

        collumns.push({
            title: 'Responsável',
            dataIndex: 'responsavel',
            width: '15%',
            renderEdit: (text, record) => {
                return (
                    <FormInput
                        span={12}
                        name='responsavel'
                        value={record.responsavel}
                        disabled
                    />
                )
            }
        })

        collumns.push({
            title: 'Status',
            dataIndex: 'statusSubcontratacao',
            width: '8%',
            renderEdit: (text, record) => {
                return (
                    <FormSelect
                        span={12}
                        options={statusSubcontratacaoOptions}
                        placeholder={'Em Cadastro'}
                        name='statusSubcontratacaoId'
                        disabled={(!(permissoes && permissoes.isPerfilAdministradorContrato)) || !existeSubcontratacaoPendente}
                    />
                )
            }
        })

        return collumns
    }

    const existeSubcontratacaoPendente = useMemo(() => {
        return subcontratacoes.some((subcontratacao) => subcontratacao.statusSubcontratacao !== 'Validada')
    }, [subcontratacoes])

    const existeSubcontratacaoPendenteSubmeter= useMemo(() => {
        return subcontratacoes.some((subcontratacao) => (subcontratacao.statusSubcontratacao !== 'Em análise' && subcontratacao.statusSubcontratacao !== 'Validada'))
    }, [subcontratacoes])

    // Permite alterar a resposta sim/não somente se não há nenhuma subcontratação cadastrada
    const podeAlterarResposta = useMemo(() => {
        return subcontratacoes.length === 0
    }, [subcontratacoes])

    const acoes: React.ReactNode = (record: any) => {
        return (
            <Row style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <ModalComentarioButton
                    tooltip='Comentários'
                    titleModal='Comentários'
                    showBadgeComments={true}
                    readonly={false}
                    loadAllComentarios={() => { return getComentariosSubcontratacaoFunc(record.id) }}
                    handleEnviarComentario={(comentario) => salvarComentarioSubcontratacao({ mensagem: comentario, subcontratacaoId: record.id })}
                />
                <Space pr={8} />
                <UploadComponent
                    idDoComponente={'anexosSubcontratacao_' + record.id}
                    id={record.id}
                    key={record.id}
                    nomeIdFormulario={'subcontratacaoId'}
                    enderecoApi={'subcontratacao/anexo'}
                    iconName={'ui-upload'}
                    type='link'
                    hasFile={false}
                    tooltip='Adicionar Autorização'
                    retorno={(response) => { onUpdate() }}
                />
                <Space pr={8} />
                <Visibility visible={isObjNotEmpty(record.anexoSubcontratacaoId)} >
                    <Tooltip title="Download Arquivo">
                        <Button
                            icon="ui-download"
                            onClick={() => downloadAnexoSubcontratacao(record.id)}
                        />
                    </Tooltip>
                    <Visibility visible={
                        record.anexoSubcontratacaoId && (GetFileExtension(record.anexoSubcontratacaoNome) === 'pdf' ||
                            imageFormats.includes(GetFileExtension(record.anexoSubcontratacaoNome)))
                    }>
                        <Tooltip title="Visualizar Arquivo">
                            <Button
                                icon="files-view_file"
                                type="link"
                                onClick={() => {
                                    viewAnexoSubcontratacao(record.id);
                                }}
                            />
                        </Tooltip>
                    </Visibility>
                </Visibility>
                <Space pr={8} />
                <Visibility visible={permissoes && permissoes.podeCadastrar && record.statusSubcontratacao != "Validada"} >
                    <Tooltip title="Deletar">
                        <Button
                            icon="ui-delete"
                            onClick={() => handleDeleteSubcontratacao(record.id)}
                        />
                    </Tooltip>
                </Visibility>
            </Row>
        )
    }

    return (
        <>
            <Visibility
                visible={
                    (dadosGerais && podeAlterarResposta) &&
                    (permissoes && (permissoes.isGestorContrato || permissoes.isFiscalContrato || permissoes.isPerfilAdministradorContrato))
                }
            >
                <Collapse bordered={false} activeKey={'salvarNovasSubcontratadasAutorizadas'} expandIcon={() => <Icon type="arrows-right_4" />}>
                    <Panel key="salvarNovasSubcontratadasAutorizadas" header={<span>Submeter Subcontratação</span>} style={{ border: 0 }}>
                        <MasterDetailForm onSubmit={onSubmitSalvarNovasSubcontratadasAutorizadas} initialValues={dadosGerais}>
                            <Widget
                                actions={[
                                    <FormSubmitButton noIcon={true} type="primary" title='Confirmar' />
                                ]}>
                                <Row className='label-overflow' >
                                    <FormSelect
                                        label='Foram autorizadas subcontratações além das já registradas no controle?'
                                        name='isNovasSubcontratadasAutorizadas'
                                        options={optionsSwitch}
                                        span={1}
                                        required
                                    />
                                </Row>
                            </Widget>
                        </MasterDetailForm>
                    </Panel>
                </Collapse>
            </Visibility>

            <Collapse bordered={false} activeKey={'cadastroSubcontratacao'} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="cadastroSubcontratacao" header={<span>Cadastro de Subcontratação</span>} style={{ border: 0 }}>
                    <MasterDetailForm
                        onSubmit={submitCadastroSubcontratacao}
                        validationSchema={Yup.object().shape({
                            subcontratada: Yup.string().required('Campo obrigatório'),
                            subcontratadacnpj: Yup.string().required('Campo obrigatório'),
                            maoDeObraEmPTR: Yup.boolean().required('Campo obrigatório'),
                            dataInicio: Yup.string().required('Campo obrigatório'),
                            dataFim: Yup.string()
                                .required('Campo obrigatório')
                                .test('date-range', 'Data fim deve ser maior ou igual a Data início', function (value) {
                                const { dataInicio } = this.parent; // Accessing the value of dataInicio
                                const startDate = new Date(dataInicio);
                                const endDate = new Date(value);

                                return !startDate || !endDate || endDate >= startDate;
                            })
                        })}
                        initialValues={initialValuesCadastro}
                    >
                        <Widget
                            actions={[
                                hasPermission(['CONTRATO_SUBCONTRATACOES_CADASTRAR']) &&
                                (permissoes && permissoes.podeCadastrar) && (
                                    <FormSubmitButton noIcon={true} type="primary" title='Incluir Subcontratação' />
                                )
                            ]}
                        >
                            <Row>
                                <FormInput span={9} name="subcontratada" label="Subcontratada" maxLength={300} />
                                <FormInput span={3} name="subcontratadacnpj" label="CNPJ" maxLength={300} />
                            </Row>
                            <Row>
                                <FormSelect span={3} name="maoDeObraEmPTR" label="Mão de obra em PTR?" options={optionsSwitch} />
                                <FormDatePicker
                                    span={3}
                                    name="dataInicio"
                                    label="Data início"
                                    format={'DD/MM/YYYY'}
                                />
                                <FormDatePicker
                                    span={3}
                                    name="dataFim"
                                    label="Data fim"
                                    format={'DD/MM/YYYY'}
                                />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Panel>
            </Collapse>

            <Collapse activeKey={'subcontratacoes'} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel key="subcontratacoes" header={<span>Subcontratações</span>} style={{ border: 0 }}>
                    <MasterDetailForm>
                        <Widget
                            actions={[
                                <Row style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                    <Visibility visible={existeSubcontratacaoPendente} >
                                        <Visibility 
                                            visible={existeSubcontratacaoPendenteSubmeter
                                            && (permissoes && (permissoes.isGestorContrato || permissoes.isFiscalContrato))}
                                        >
                                            <Space pr={8} />
                                            <Button
                                                title='Submeter'
                                                type='success'
                                                onClick={() => onClickSubmeter()}
                                            />
                                        </Visibility>
                                        <Visibility visible={permissoes && permissoes.podeConfirmar} >
                                            <Space pr={8} />
                                            <Button title='Salvar' type='success' onClick={() => onClickDevolver()} />
                                        </Visibility>
                                    </Visibility>
                                </Row>
                            ]}
                        >
                            <Row>
                                <InlineEditTable
                                    dataSource={subcontratacoes}
                                    columns={columns()}
                                    pagination={false}
                                    updateItem={handleEditSubcontratacao}
                                    disablenotification={false}
                                    renderActions={(text, record) => acoes(record)}
                                />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Panel>
            </Collapse>
        </>
    )
}
